(function ($) {
    $('.js-component-container').each(function () {
        var $this = $(this);
        $this.data('code', $this.html());
    });
})(jQuery);

$(function () {
    // shows source code of style guide components
    $('.btn-code').on('click', function () {
        var $this = $(this);
        var id = $this.data('id'),
            $srcElement = $('#' + id + '-source');
        if ($srcElement.length === 0) {
            var $target = $('#' + id),
                code = $target.data('code') || $target.html() || '';

            code = code.replace(/</g, '&lt;');
            code = code.replace(/>/g, '&gt;');
            $this.after('<pre id="' + id + '-source" class="code-source"><code>' + code + '</pre></code>');
            $('#' + id + '-source').slideDown('fast');
        }
        else {
            $srcElement.slideToggle('fast');
        }
    });

    $('.hero-banner .flexslider').not('#hero-slider-code .flexslider').homeCarousel();

    // Bind the slick on init *before* slick is initialized
    $('#slickDemoCarousel').on('init', function (event, slick) {
        if (slick.options.autoplay == true) {
            initSlickPlayPause($(this));
        }
    });

    // Now initialize slick
    $('#slickDemoCarousel').slick({
        "arrows": true,
        "autoplay": true
    });

    function initSlickPlayPause(carouselElement) {
        carouselElement.prepend('<button id="slickPlayPause" aria-label="Pause Carousel" class="slick-play-pause icon-pause2"></button>');

        $('#slickPlayPause').on('click', function () {
            var $button = $(this);

            if ($button.hasClass('icon-play')) {
                carouselElement.slick('slickPlay');
                $button.addClass('icon-pause2');
                $button.removeClass('icon-play');

                setTimeout(function () {
                    $button.attr('aria-label', 'Pause Carousel');
                }, 50)
            } else if ($button.hasClass('icon-pause2')) {
                carouselElement.slick('slickPause')
                $button.addClass('icon-play');
                $button.removeClass('icon-pause2');
                setTimeout(function () {
                    $button.attr('aria-label', 'Play Carousel');
                }, 50)
            }
        });
    }

    var $styleGuideAnchorNavSpan = $('.style-guide-anchor-span');
    $styleGuideAnchorNavSpan.on('click', function (e) {
        e.preventDefault();
        $('.style-guide-anchor-nav').toggleClass('active');
    });

    $('.style-guide-anchor-nav').on('click touchstart', function (e) {
        e.stopPropagation();
    })

    $('body').on('click touchstart', function () {
        $('.style-guide-anchor-nav').removeClass('active');
    })

    var $styleGuideAnchorList = $('.style-guide-anchor-nav ul');
    //set up the anchor nav links
    $('.style-guide-section').each(function () {
        var id = this.id,
            title = $(this).children('h2:first').text();

        if (id && title)
            $styleGuideAnchorList.append('<li class="style-guide-anchor-item"><a href="#' + id + '" class="style-guide-anchor-link js-scroll-to-link">' + title + '</a></li>')
    });

    if ($.fn.scrollToID) {
        $('.js-scroll-to-link').scrollToID();
    }

    //Init accordions
    $('.mobile-accordion-group').mobileAccordion();
    $('.desktop-accordion-group').mobileAccordion({ desktopAccordion: true });

    //Init hidden inputs
    $('.js-hidden-input').hiddenInput();
});